import { render, staticRenderFns } from "./AppDetailTab1.vue?vue&type=template&id=9c524bd4&scoped=true";
import script from "./AppDetailTab1.vue?vue&type=script&lang=js";
export * from "./AppDetailTab1.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab1.vue?vue&type=style&index=0&id=9c524bd4&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "9c524bd4", null);
export default component.exports;